export enum  CatalogItemVersionStatus {
  Draft = 1,
  InReview = 2,
  Published = 3,
  Retired = 4
}